import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

export function CalloutWarning({ children }: { children: ReactNode }) {
  return (
    <div className="my-6 flex gap-3 rounded-lg border-l-4 border-status-warning-border bg-status-warning-bg p-4">
      <AlertTriangle
        className="mt-0.5 h-5 w-5 shrink-0 text-status-warning-text"
        aria-hidden
      />
      <div className="text-sm text-text-primary">{children}</div>
    </div>
  );
}
